// Demo team. Replace names, roles and bios with real SDL team members.
// Add `photo` (a path/URL) to show a real photo; otherwise a generated avatar is shown.
export const team = {
  title: 'Meet Our Team',
  text: 'The engineers, designers and analysts behind Sheba Digital Limited, working together to deliver dependable technology.',
  members: [
    { name: 'Team Member Name', role: 'Managing Director', bio: 'Leads company vision and long-term client partnerships.', photo: '' },
    { name: 'Team Member Name', role: 'Head of Engineering', bio: 'Oversees architecture, delivery and engineering quality.', photo: '' },
    { name: 'Team Member Name', role: 'Lead Software Engineer', bio: 'Builds and reviews scalable backend and web platforms.', photo: '' },
    { name: 'Team Member Name', role: 'Mobile Application Lead', bio: 'Delivers Android, iOS and cross-platform applications.', photo: '' },
    { name: 'Team Member Name', role: 'UI/UX Designer', bio: 'Designs clear, usable interfaces and user journeys.', photo: '' },
    { name: 'Team Member Name', role: 'Quality Assurance Lead', bio: 'Keeps releases reliable through structured testing.', photo: '' },
  ],
};
